class ComponentSearchPredictive extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.clear = this.querySelector('#search-bar .search-form__icon-close');
        this.predictiveSearchResults = this.querySelector('#predictive-search');
        this.overlay = this.querySelector('#search-overlay');

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));

        this.clear.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
        });

        this.overlay.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
        });
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        // fetch(`/search/suggest.json?q=${searchTerm}&section_id=predictive-search`)
        fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
                this.predictiveSearchResults.innerHTML = resultsMarkup;
                this.open();
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    open() {
        document.querySelector("#MainContent").style['z-index'] = 1;
        document.querySelector(".focus-tint").style.display = 'none';
        document.querySelector(".header-content").getBoundingClientRect();
        console.log(document.querySelector(".header-content").getBoundingClientRect());
        this.predictiveSearchResults.style.display = 'block';
        this.overlay.style.display = 'block';
        document.querySelector("#search-overlay-mobile").style.display = 'block';
        document.body.style.overflow = 'hidden';
    }

    close() {
        document.querySelector("#MainContent").style['z-index'] = 200;
        this.predictiveSearchResults.style.display = 'none';
        this.overlay.style.display = 'none';
        document.querySelector("#search-overlay-mobile").style.display = 'none';
        this.input.value = '';
        document.body.style.overflow = 'auto';
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define('predictive-search', ComponentSearchPredictive);

document.addEventListener("DOMContentLoaded", function() {
    const minRange = document.querySelector('.rangeslider .min');
    const maxRange = document.querySelector('.rangeslider .max');
    const minValueInput = document.querySelector('.dualslider-range-1');
    const maxValueInput = document.querySelector('.dualslider-range-2');

    // save values choose by user
    function saveRangeValues() {
        sessionStorage.setItem('minRangeValue', minRange.value);
        sessionStorage.setItem('maxRangeValue', maxRange.value);
    }

    // Get the slider values
    function loadRangeValues() {
        const savedMinValue = sessionStorage.getItem('minRangeValue');
        const savedMaxValue = sessionStorage.getItem('maxRangeValue');
        if (savedMinValue && savedMaxValue) {
            minRange.value = savedMinValue;
            maxRange.value = savedMaxValue;
            updateInputValues();
        }
    }

    updateInputValues();

    function updateInputValues() {
        minValueInput.value = minRange.value;
        maxValueInput.value = maxRange.value;
    }

    // Update min and max values for the slider
    function updateRangeLimits() {
        const minVal = parseInt(minRange.value, 10);
        const maxVal = parseInt(maxRange.value, 10);

        // Lock minimum slider if necessary
        if (minVal >= maxVal) {
            minRange.value = maxVal - 1;
        }

        // Lock maximum slider if necessary
        if (maxVal <= minVal) {
            maxRange.value = minVal + 1;
        }
    }

    minRange.addEventListener('input', function() {
        updateInputValues();
        saveRangeValues();

        // Make sure minRange does not fall below maxRange
        if (parseInt(minRange.value, 10) >= parseInt(maxRange.value, 10)) {
            minRange.value = parseInt(maxRange.value, 10) - 1;
        }

        updateInputValues();
        saveRangeValues();

    });

    maxRange.addEventListener('input', function() {
        updateInputValues();
        saveRangeValues();

        // Make sure maxRange does not fall below minRange
        if (parseInt(maxRange.value, 10) <= parseInt(minRange.value, 10)) {
            maxRange.value = parseInt(minRange.value, 10) + 1;
        }

        updateInputValues();
        saveRangeValues();
    });

    updateRangeLimits();
    loadRangeValues();
});
